import { useVideoPlayerComponent } from "@outschool/ui-components-shared";
import { VideoPlayerProps } from "@outschool/ui-legacy-component-library";
import React from "react";

export default function MuxVideoPlayer({
  videoPlaybackID,
  thumbnailUrl = `https://image.mux.com/${videoPlaybackID}/thumbnail.jpg?time=0`,
  ...otherProps
}: Omit<VideoPlayerProps, "src"> & {
  videoPlaybackID: string;
  thumbnailUrl?: string;
}) {
  const VideoComponent = useVideoPlayerComponent();
  const src = `https://stream.mux.com/${videoPlaybackID}.m3u8`;
  return (
    <VideoComponent
      key={videoPlaybackID}
      poster={thumbnailUrl}
      src={src}
      {...otherProps}
    />
  );
}
